import {
    DELETE_ACCOUNT_TYPE_MAPPING_ADMIN_SUCCESS,
    DELETE_ACCOUNT_TYPE_MAPPING_ADMIN_FAILED,
    LOADING_DELETE_ACCOUNT_TYPE_MAPPING_ADMIN,
    RESET_DELETE_ACCOUNT_TYPE_MAPPING_ADMIN,
    NETWORK_DELETE_ACCOUNT_TYPE_MAPPING_ADMIN
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DELETE_ACCOUNT_TYPE_MAPPING_ADMIN:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case DELETE_ACCOUNT_TYPE_MAPPING_ADMIN_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case DELETE_ACCOUNT_TYPE_MAPPING_ADMIN_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_DELETE_ACCOUNT_TYPE_MAPPING_ADMIN:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_DELETE_ACCOUNT_TYPE_MAPPING_ADMIN:
            return (state = initialState);
        default:
            return state;
    }
};
